import { Capacitor } from '@capacitor/core';

/**
 * Adaptador central de plataforma.
 *
 * Aísla toda detección de "¿corremos dentro de la app nativa (Capacitor) o en la
 * web?" en un único punto. El resto de la app importa desde aquí en vez de llamar
 * a `Capacitor.*` directamente, de forma que la lógica web actual no cambia.
 */

/** `true` cuando la app corre empaquetada en iOS/Android (WebView de Capacitor). */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/** `'ios' | 'android' | 'web'`. */
export function getPlatform(): 'ios' | 'android' | 'web' {
  return Capacitor.getPlatform() as 'ios' | 'android' | 'web';
}

export const isIOS = (): boolean => getPlatform() === 'ios';
export const isAndroid = (): boolean => getPlatform() === 'android';

// release-test: verificar ciclo de release iOS con cert fijo (build 4)
